import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const EventIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Event`} {...props}>
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 1.826C0 .818.818 0 1.826 0h8.348C11.182 0 12 .818 12 1.826v8.348A1.826 1.826 0 0 1 10.174 12H1.826A1.826 1.826 0 0 1 0 10.174V1.826Zm1.826-.26a.26.26 0 0 0-.26.26V2.87h8.869V1.826a.26.26 0 0 0-.261-.26H1.826ZM2 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Z"
      clipRule="evenodd"
    />
  </Icon>
);
